export default __webpack_public_path__ + "static/media/1(3).c6319e27.jpg";